export const SIGNUP_EMAIL_OTP_REQUIRED_CONTEXT = '/signed_up_verification_otp_sent_to_email'
export const SIGNUP_EMAIL_VERIFICATION_ROUTE = '/verify-email'

export type SignupEmailVerificationRouteParams = {
  email: string
  tenant?: string
  orgInstanceId?: string
  otpLength?: number
}

export const isSignupEmailOtpVerificationContext = (context?: string | null) =>
  context === SIGNUP_EMAIL_OTP_REQUIRED_CONTEXT

export const buildSignupEmailVerificationPath = ({
  email,
  tenant,
  orgInstanceId,
  otpLength,
}: SignupEmailVerificationRouteParams) => {
  const params = new URLSearchParams()
  params.set('email', email)

  if (tenant) {
    params.set('tenant', tenant)
  }

  if (orgInstanceId) {
    params.set('org', orgInstanceId)
  }

  if (typeof otpLength === 'number' && Number.isFinite(otpLength) && otpLength > 0) {
    params.set('otpLength', String(otpLength))
  }

  return `${SIGNUP_EMAIL_VERIFICATION_ROUTE}?${params.toString()}`
}